import { CriteriaConfig, LogCriteria, LogFilterType } from 'src/dtos/search-criteria.dto';
import { AllowDropRuleAction, DirectionFilterNames, getEnumOptions, TimeRange } from 'src/utils/enums';
import { checkPort } from 'src/utils/validationUtils';
import { FwVersion } from 'src/dtos/version.dto';
import { checkSingleIp } from 'src/utils/ipValidationUtil';

export const trafficFilteringCriteriaConfig: (version: FwVersion | undefined) => CriteriaConfig<LogCriteria>[] = (version) => {
    const ruleNamesOptions = [
        { value: 'All', label: 'All' },
        ...(version?.content.policy.rules.map((rule, index) => ({
            value: rule.displayName,
            label: `${index + 1}: ${rule.displayName}`
        })) || [])
    ];

    return [{
        accessor: 'timeDetails',
        header: 'Time',
        type: LogFilterType.TIME,
        defaultValue: TimeRange.LAST_24_HOURS,
        width: 305,
        options: getEnumOptions(TimeRange),
        allowedDaysAgo: 39
    },
    {
        accessor: 'direction',
        header: 'Direction',
        type: LogFilterType.DROP_DOWN,
        options: getEnumOptions(DirectionFilterNames).filter(item => item.label !== DirectionFilterNames.BOTH),
        defaultValue: DirectionFilterNames.ALL,
        width: 115
    },
    {
        accessor: 'sourceIp',
        header: 'Source IP',
        type: LogFilterType.INPUT,
        defaultValue: '',
        width: 140,
        validationRules: [checkSingleIp]
    },
    {
        accessor: 'destIp',
        header: 'Destination IP',
        type: LogFilterType.INPUT,
        defaultValue: '',
        width: 140,
        validationRules: [checkSingleIp]
    },
    {
        accessor: 'dport',
        header: 'To Port',
        type: LogFilterType.INPUT_NUMBER,
        defaultValue: '',
        width: 70,
        validationRules: [checkPort]
    },
    {
        accessor: 'application',
        header: 'Application',
        type: LogFilterType.INPUT,
        defaultValue: '',
        width: 125
    },
    {
        accessor: 'action',
        header: 'Action',
        type: LogFilterType.DROP_DOWN,
        options: getEnumOptions(AllowDropRuleAction),
        defaultValue: AllowDropRuleAction.ALL,
        width: 100
    },
    {
        accessor: 'rule',
        header: 'Rule',
        type: LogFilterType.DROP_DOWN,
        options: ruleNamesOptions,
        defaultValue: 'All',
        width: 305
    }];
};
